module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-wrapper swiper-slide",
    style: (("background-image: url(" + _vm.background + ");"))
  }, [_vm._t("default"), _vm._v(" "), (_vm.hasDownBtn) ? _c('img', {
    staticClass: "down-btn ani animate__infinite",
    attrs: {
      "swiper-animate-effect": "animate__bounce",
      "src": "/static/img/anniversary/down.png"
    },
    on: {
      "click": _vm.handleButtonClick
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c69b057c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Anniversary/PageWrapper.vue
// module id = 1720
// module chunks = 8